module.exports = __webpack_public_path__ + "static/media/GalleryImage08.ed77d834.jpg";